// this component was automatically generated by IconGlyph.template.js
import React from 'react';
import { TestId } from '@trello/test-ids';

import { Icon, IconColor, IconSize } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon. Usually it
   * matches up with the display name of the icon
   * @default If no label is provided, it will fallback to the name of the icon
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default @icon-default-color (#42526E)
   */
  color?: IconColor;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-test-id) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
  /**
   * The switch for the icon to be centered in the dedicated space with padding around it.
   * Designed for cases when icon is not inline.
   */
  block?: boolean;
}

const RemoveMemberIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0254 3C9.25613 3 7.01123 5.23858 7.01123 8C7.01123 9.44777 7.62829 10.7518 8.61446 11.6649C5.52103 12.925 3.28572 15.8477 3.02539 19.3193C3.1787 20.2721 4.00691 21 5.00562 21L11 21C11.5523 21 12 20.5523 12 20C12 19.4477 11.5523 19 11 19H5.0767C5.56331 15.6077 8.48892 13 12.0254 13C13.7913 13 15.405 13.6503 16.6387 14.7238C16.8358 14.8953 17.0844 15 17.3457 15H17.6553C18.4554 15 18.9052 14.1202 18.332 13.5618C17.5052 12.7563 16.5237 12.1079 15.4362 11.6649C16.4224 10.7518 17.0395 9.44777 17.0395 8C17.0395 5.23858 14.7946 3 12.0254 3ZM15.0338 8C15.0338 9.65685 13.6869 11 12.0254 11C10.3638 11 9.01688 9.65685 9.01688 8C9.01688 6.34315 10.3638 5 12.0254 5C13.6869 5 15.0338 6.34315 15.0338 8Z"
        fill="currentColor"
      />
      <path
        d="M22 18C22 17.4477 21.5523 17 21 17H15C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19H21C21.5523 19 22 18.5523 22 18Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RemoveMemberIcon: React.FunctionComponent<GlyphProps> = (
  props,
) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  return (
    <Icon
      testId={testId}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label || 'RemoveMemberIcon'}
      glyph={RemoveMemberIconGlyph}
    />
  );
};
